<div class="container-fluid px-0">
  <app-vendor-service [providerInfo]="providerInfo" *ngIf="providerInfo"></app-vendor-service> 
</div>
